import axios from "axios";
import instance from "../../../axios";
import instanceTokenLess from "../../../axiosTokenLess";

export const API_URL = `${process.env.REACT_APP_API_URL}`;
export const API_URL_V2 = `${process.env.REACT_APP_API_URL_V2}`;
export const API_URL_H5 = `${process.env.REACT_APP_GAMERJI_API_URL}`;

// READ
// export function getSearchList(queryParams) {
//   return axios.post(`${API_URL}/${queryParams.source}/search`, queryParams.filter);
// }
export const getCountryList = () => {
  return instance.post(`${API_URL}/country/dropdown/list`, {
    "pagination": {
      "pageNo": 1,
      "recordPerPage": 1000,
      "sortBy": "name",
      "sortDirection": "desc"
    }
  }
  )
    .then(res => {
      return res;
      //  console.log(res)
    })
}
export const getSearchList = (queryParams) => {
  return instance.post(`${API_URL_H5}/${queryParams.source}/search`, queryParams.filter)
    .then(res => {
      return res;
    })
}
export function getGameList(queryParams) {
  return axios.post(`${API_URL}/${queryParams.source}/list`, queryParams.filter);
}

export function getSaasGameList(queryParams) {
  // return instance.post(`${API_URL}/${queryParams.source}/list`, queryParams.filter)
  // .then(res => {
  //     return res;
  // })
  return instance.post(`${API_URL}/v3/dropdown/game/medium`, queryParams.filter)
  .then(res => {
      return res;
    })
}
export function getH5GamesList(queryParams) {
  return instanceTokenLess.post(`${API_URL_H5}/${queryParams.source}/search`, queryParams.filter)
    .then(res => {
      return res;
    })
}
export function getGameTypeList(queryParams) {
  return instance.post(`${API_URL_V2}/gametype/assign/list/`, queryParams.filter)
    .then(res => {
      return res;
    })
}

export const getCompanyList = () => {
  return instance.post(`${API_URL}/company/dropdown/list`, {
    "pagination": {
      "pageNo": 1,
      "recordPerPage": 1000,
      "sortBy": "name",
      "sortDirection": "desc"
    }
  }
  )
    .then(res => {
      return res;
      // console.log(res)
    })
}

export const getPermissionList = (data) => {
  // console.log("getPermissionList>>>>>>>>>payload",data)
  return instance.post(`${API_URL}/role/permission-list`, data
  )
    .then(res => {
      return res;
      // console.log(res)
    }).catch(err => {
      return ({
        "success": false,
      });
    })
}